import Store from '@ember-data/store';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import WebauthnRegisterOptionModel from 'donor-elf-web/models/webauthn/register-option';
import NavbarSettingsService from 'donor-elf-web/services/navbar-settings';
import Changeset from 'ember-changeset';
import lookupValidator from 'ember-changeset-validations';
import { validatePresence } from 'ember-changeset-validations/validators';

export interface PasskeysAddModel {
  registerOption: WebauthnRegisterOptionModel;
  changeset: any;
}

const webAuthnValidation = {
  nickName: validatePresence({ presence: true, message: "Can't be blank" }),
};

export default class PasskeysAddRoute extends Route {
  @service declare navbarSettings: NavbarSettingsService;
  @service declare store: Store;

  beforeModel() {
    this.navbarSettings.title = 'Add Passkey';
  }

  async model() {
    let registerOption = await this.store.findRecord(
      'webauthn/register-option',
      Number(new Date()),
    );
    let changeset = new Changeset(
      this.store.createRecord('webauthn/register-verification', {}),
      lookupValidator(webAuthnValidation),
      webAuthnValidation,
    );
    return {
      registerOption,
      changeset,
    };
  }
}
